import * as React from 'react'
import * as classnames from 'classnames'

import * as styles from './section.css'

import { injectStores } from '../../../store'
import { observer } from 'mobx-react'
import { VertiefungBox } from '../vertiefungBox/vertiefungBox'
import { ScrollPageChild } from '../../common/scrollpage'
import { ContentChapter, ContentSection } from '../storydocStoreContent'
import { Drawer } from '../drawer/drawer'
import { Timeline } from '../drawer/timeline'
import { Throttle } from 'lodash-decorators/throttle'
import { observable } from 'mobx'
import { colorHexAlpha } from '../../../utils/Color'
import posed from 'react-pose'
import bind from 'bind-decorator'
// import { Portal } from 'react-portal'

// const Hypher = require('hypher')
// const german = require('hyphenation.de')
// const h = new Hypher(german)

const raster = require('../../common/icons/raster.svg')
const animatedOpenButton = require('../../common/icons/mobile-timeline.svg')

const buttonProps = {
  open: { opacity: 1, x: '0%', transition: { duration: 700, ease: 'easeOut' } },
  closed: { opacity: 0, x: '-100%', transition: { duration: 700, ease: 'easeIn' } }
}

const AnimatedButton = posed.div(buttonProps)

export interface ISection {
  data?: ContentChapter
  section: ContentSection
  active: boolean
}

@injectStores
@observer
export class Section extends ScrollPageChild<ISection> {
  @observable autoScrollVertiefungen = true
  element: HTMLDivElement | null = null
  stickyVA: HTMLDivElement | null = null
  vertiefungenElem: HTMLDivElement | null = null

  @observable drawerClose = false

  componentDidMount () {
    //   setTimeout(() => {
    //     if (this.element && this.element.scrollIntoView && this.store.storyDocUI.currentSlideIdx === this.props.section.idx - 1) {
    //       console.log('section scroll into view mount')
    //       this.element.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' })
    //     }
    //   }, 500)
    this.addListeners()
  }

  @bind
  addListeners () {
    if (this.stickyVA) {
      this.stickyVA.addEventListener('scroll', this.isolateTouch)
      this.stickyVA.addEventListener('touchstart', this.isolateTouch)
      this.stickyVA.addEventListener('touchmove', this.isolateTouch)
      this.stickyVA.addEventListener('touchend', this.isolateTouch)
      this.stickyVA.addEventListener('touchcancel', this.isolateTouch)
      this.stickyVA.addEventListener('dragstart', this.isolateTouch)
      this.stickyVA.addEventListener('drag', this.isolateTouch)
      this.stickyVA.addEventListener('dragend', this.isolateTouch)
      this.stickyVA.addEventListener('mouseenter', this.isolateTouch)
      this.stickyVA.addEventListener('mouseleave', this.isolateTouch)
      this.stickyVA.addEventListener('mousedown', this.isolateTouch)
      this.stickyVA.addEventListener('mouseup', this.isolateTouch)
      this.stickyVA.addEventListener('mousemove', this.isolateTouch)
    }

    if (this.vertiefungenElem) {
      this.vertiefungenElem.addEventListener('touchstart', () => this.autoScrollVertiefungen = false)
      // this.vertiefungenElem.addEventListener('touchmove', () => this.autoScrollVertiefungen = false)
      // this.vertiefungenElem.addEventListener('touchend', () => this.autoScrollVertiefungen = false)
    }
  }

  componentWillUnmount () {
    if (this.stickyVA) {
      this.stickyVA.removeEventListener('scroll', this.isolateTouch)
      this.stickyVA.removeEventListener('touchstart', this.isolateTouch)
      this.stickyVA.removeEventListener('touchmove', this.isolateTouch)
      this.stickyVA.removeEventListener('touchend', this.isolateTouch)
      this.stickyVA.removeEventListener('touchcancel', this.isolateTouch)
      this.stickyVA.removeEventListener('dragstart', this.isolateTouch)
      this.stickyVA.removeEventListener('drag', this.isolateTouch)
      this.stickyVA.removeEventListener('dragend', this.isolateTouch)
      this.stickyVA.removeEventListener('mouseenter', this.isolateTouch)
      this.stickyVA.removeEventListener('mouseleave', this.isolateTouch)
      this.stickyVA.removeEventListener('mousedown', this.isolateTouch)
      this.stickyVA.removeEventListener('mouseup', this.isolateTouch)
      this.stickyVA.removeEventListener('mousemove', this.isolateTouch)
    }
  }

  isolateTouch (e: any) {
    this.autoScrollVertiefungen = false
    e.stopPropagation()

    // e.preventDefault()
  }

  isRender () {
    return (this.props.active) && (this.props.scrollPos || this.props.scrollPos === 0) && (this.props.scrollPos > -1 && this.props.scrollPos < 2)
  }

  isRouterPush () {
    return (this.props.scrollPos || this.props.scrollPos === 0) && (this.props.scrollPos >= 0 && this.props.scrollPos <= 1)
  }

  isFade (): boolean {
    return this.store.storeCommon.currentStory.vertiefungExpanded || this.store.storeCommon.currentStory.timelineExpanded
  }

  @Throttle(500)
  updateUrl () {
    if (this.isRouterPush()) {
      this.store.storeRouter.replace(`${this.store.storeRouter.location.pathname}#${this.props.section.id}`)
    }
  }

  componentDidUpdate () {
    this.addListeners()
    if (this.isRender()) {
      this.updateUrl()

    }
  }

  render () {
    // console.log(`${this.store.storyDocUI.currentSlideIdx} ${this.props.section.idx}`)
    let sticky: JSX.Element | null = null
    let vertiefungen: JSX.Element | null = null
    let stickyVertiefungen: JSX.Element | null = null
    let colorOverlay: JSX.Element | null = null
    let chapterNumber: JSX.Element | null = null
    let timeline: JSX.Element | null = null
    let whiteOverlay: JSX.Element | null = null
    let mobileOpenButton: JSX.Element | null = null

    const subContents = []

    sticky = <div className={styles.stickyHolder}></div>

    let size = 150
    if (0.8 * this.store.storeCommon.window.height / this.props.section.subcontentRef.length < 100) {
      size = 90
    } else if (0.8 * this.store.storeCommon.window.height / this.props.section.subcontentRef.length < 150) {
      size = 110
    }

    if (this.isRender() && this.props.active) {
      for (const subcont of this.props.section.subcontentRef) {
        subContents.push(<VertiefungBox
                            vertiefung={subcont}
                            key={subcont.id}
                            size={size}
                            onExpandClick={() => this.store.storeCommon.currentStory.vertiefungExpanded = !this.store.storeCommon.currentStory.vertiefungExpanded}
                          />)
      }

      if (this.props.data && this.props.data.idx > 0) {

        vertiefungen = (
          <div className={classnames(styles.vertiefungsArea, this.autoScrollVertiefungen && this.store.breakpoints.phone && subContents.length > 2 && this.props.scrollPos && this.props.scrollPos > 0.2 ? styles.animatedStickyVertiefungen : undefined)}
            style={{
              animationDuration: this.autoScrollVertiefungen ? `${5 * subContents.length}s` : '0s'
              // animationPlayState: this.autoScrollVertiefungen ? 'running' : 'paused'
              // transform: `translateX(-${this.props.scrollPos ? this.props.scrollPos * 100 : 0}%)`
            }}
            ref={elem => this.vertiefungenElem = elem}
          >
            {subContents}
          </div>
        )
      }

      if (this.store.breakpoints.phone && this.store.appStore.online && this.props.data && this.props.data.idx > 0) {
        stickyVertiefungen = <div className={classnames(styles.stickyVertiefungen)} ref={elem => this.stickyVA = elem}>
                               {vertiefungen}
                             </div>
      }

      const color = colorHexAlpha(this.props.data && this.props.data.color, 0.3)

      colorOverlay = <div className={styles.colorOverlay} style={{ backgroundImage: `linear-gradient(${color}, ${color}), url(${raster})` }} ></div>

      const bgOpacity = this.props.scrollPos ? Math.max(Math.min(this.props.scrollPos * 5 + 0.5, 1.0), 0.5) : 0.5

      whiteOverlay = <div className={styles.whiteOverlay} style={{ opacity: bgOpacity }} ></div>

      if (this.props.data && this.props.data.idx > 0) {
        chapterNumber = <div className={styles.chapterNumber}><img src={this.props.data ? this.props.data.icon : null} alt='chapter_#' /></div>
      }

      if (this.props.data && this.props.data.idx === 0) {
        mobileOpenButton = <AnimatedButton pose={this.store.storeCommon.currentStory.timelineExpanded ? 'closed' : 'open'} className={styles.mobileOpenButton} onClick={() => this.store.storeCommon.currentStory.timelineExpanded = !this.store.storeCommon.currentStory.timelineExpanded}>
          <img src={animatedOpenButton} alt='open-timeline-button' />
          <div className={styles.openButtonText}>Konrad Adenauers Leben</div>
        </AnimatedButton>

        if (this.store.breakpoints.desktop) {
          timeline = <Timeline />
        } else {
          timeline = <Timeline open={this.store.storeCommon.currentStory.timelineExpanded} onExpandClick={() => this.store.storeCommon.currentStory.timelineExpanded = !this.store.storeCommon.currentStory.timelineExpanded} />
        }
      }

      sticky = <div className={styles.stickyHolder} style={{ backgroundImage: this.store.breakpoints.desktop ? `url(${this.props.section.urlBGImage})` : `url(${this.props.section.urlBGImageMobile})` }}>
                {this.store.breakpoints.desktop && vertiefungen}
                {colorOverlay}
                {whiteOverlay}
                <Drawer data={this.props.section} isFade={this.isFade()} closeOnScroll={this.drawerClose}/>
                {this.store.breakpoints.desktop && timeline}
                {this.store.breakpoints.desktop && chapterNumber}
              </div>
    }

    return (
      <div className={styles.section} id={this.props.section.id} ref={elem => {
        this.element = elem
        // const { hash } = window.location
        // if (hash !== '') {
        //   const id = hash.replace('#', '')
        //   if (elem && elem.id === id) elem.scrollIntoView()
        // }
      }}>
        {sticky}
        <div className={styles.textBox}>
          {this.store.breakpoints.phone && mobileOpenButton}
          {this.store.breakpoints.phone && timeline}
          <div className={styles.title} style={this.props.section.title.includes('Jahrhundert') ? { hyphens: 'none' } : undefined}>
            {/* {h.hyphenateText(this.props.section.title.replace(/\.\s/g,'\.\u00a0'))} */}
            {this.props.section.title.replace(/\.\s/g,'\.\u00a0')}
          </div>
          <div className={styles.text} dangerouslySetInnerHTML={{ __html: this.props.section.textHtml }} />
        </div>
        {stickyVertiefungen}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/storydoc/book/section.tsx